import React, { Component, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import dateFormat from 'dateformat';
import { parseDate, padNum } from '../../utils/web/index.js';
import { useEnterKey } from '../reactHooks.js';
import './input.scss';

function Input(props) {
  var {
    className = null,
    label,
    onChange,
    onClick,
    onKeyUp,
    placeholder = '',
    style = {},
    tooltip = null,
    type = 'text',
    value
  } = props;
  var [tooltipOpen, setTooltipOpen] = useState(false);
  var onEnter = useEnterKey(onClick);
  var labelClass = classNames('myInput', className);
  var tooltipDiv = tooltip && /*#__PURE__*/React.createElement("span", {
    className: "tooltip",
    onMouseOver: () => setTooltipOpen(true),
    onMouseOut: () => setTooltipOpen(false)
  }, "?", tooltipOpen && /*#__PURE__*/React.createElement("span", {
    className: "tooltipText"
  }, tooltip));
  var componentProps = { ...props,
    labelClass,
    tooltipDiv
  };

  if (inputComponents[type]) {
    var InputComponent = inputComponents[type];
    return /*#__PURE__*/React.createElement(InputComponent, componentProps);
  } else if (type === 'checkbox') {
    return /*#__PURE__*/React.createElement("label", {
      className: classNames(labelClass, 'checkboxContainer'),
      style: style
    }, /*#__PURE__*/React.createElement("input", {
      onChange: event => onChange(event.target.checked),
      type: "checkbox",
      checked: value
    }), label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv));
  } else if (type === 'switch') {
    return /*#__PURE__*/React.createElement("label", {
      className: classNames(labelClass, 'switchLabel'),
      onClick: () => onChange(!value),
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('switch', {
        switchOn: value
      }, labelClass)
    }, /*#__PURE__*/React.createElement("div", null)));
  } else if (type === 'button') {
    return /*#__PURE__*/React.createElement("label", {
      className: classNames(labelClass, 'buttonContainer'),
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      tabIndex: "0",
      className: "button",
      onClick: event => onClick(event),
      onKeyUp: onEnter
    }, label, tooltipDiv));
  } else if (type === 'datetime') {
    var onDateChange = newValue => {
      newValue.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds());
      onChange(newValue);
    };

    var onTimeChange = newValue => {
      var [hours, minutes] = newValue.split(':').map(num => parseInt(num));
      value = new Date(value.getTime());
      value.setHours(hours, minutes);
      onChange(value);
    };

    return /*#__PURE__*/React.createElement("label", {
      className: labelClass,
      style: style
    }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
      className: "dateTimeContainer"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "date",
      value: value,
      onChange: onDateChange
    }), /*#__PURE__*/React.createElement(Input, {
      type: "time",
      value: dateFormat(value, 'HH:MM'),
      onChange: onTimeChange
    })));
  } else if (type === 'number') {
    return /*#__PURE__*/React.createElement("label", {
      className: classNames('number', labelClass),
      style: style
    }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("input", {
      className: "inputBox",
      onChange: event => onChange(parseFloat(event.target.value) || ''),
      placeholder: placeholder,
      type: "number",
      value: value,
      onKeyUp: onKeyUp
    }));
  } else if (type === 'percent') {
    return /*#__PURE__*/React.createElement("label", {
      className: classNames('percent', labelClass),
      style: style
    }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("input", {
      className: "inputBox",
      onChange: event => onChange(isNaN(parseFloat(event.target.value)) ? event.target.value : event.target.value / 100),
      placeholder: placeholder,
      type: "number",
      value: isNaN(parseFloat(value)) ? value : value * 100,
      onKeyUp: onKeyUp
    }));
  } else if (type === 'password') {
    return /*#__PURE__*/React.createElement("label", {
      className: labelClass,
      style: style
    }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("input", {
      className: "inputBox",
      onChange: event => onChange(event.target.value),
      placeholder: placeholder,
      type: type,
      value: value,
      onKeyUp: onKeyUp
    }));
  } else {
    return /*#__PURE__*/React.createElement(TextInput, componentProps);
  }
}

function SinglePill(props) {
  var {
    label,
    labelClass,
    onChange,
    onKeyUp,
    style = {},
    tooltipDiv,
    value
  } = props;
  var [pillFocus, setPillFocus] = useState(null);

  var addPill = () => onChange([...value, ['', '']]);

  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
    className: "pillScrollContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pillContainer",
    style: {
      width: value.length * 115 + 45
    }
  }, value.map((next, i) =>
  /*#__PURE__*/
  // maybe see if these can dynamically change width depending on content (with min/max width)
  React.createElement("div", {
    className: classNames('singlePill', {
      pillFocus: pillFocus === i
    }),
    key: i
  }, /*#__PURE__*/React.createElement("input", {
    onChange: event => {
      value[i] = event.target.value;
      onChange(value);
    } // placeholder={'From'}
    ,
    type: "text",
    value: next,
    onFocus: () => setPillFocus(i),
    onBlur: () => setPillFocus(null),
    onKeyUp: onKeyUp
  }))), /*#__PURE__*/React.createElement("div", {
    className: "addPillButton",
    onClick: addPill
  }, "+"))));
}

function DoublePill(props) {
  var {
    label,
    labelClass,
    onChange,
    onKeyUp,
    style = {},
    tooltipDiv,
    value
  } = props;
  var [pillFocus, setPillFocus] = useState(null);

  var addPill = () => onChange([...value, ['', '']]);

  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
    className: "pillScrollContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pillContainer",
    style: {
      width: value.length * 175 + 45
    }
  }, value.map((next, i) => /*#__PURE__*/React.createElement("div", {
    className: classNames('doublePill', {
      pillFocus: pillFocus === i
    }),
    key: i
  }, /*#__PURE__*/React.createElement("input", {
    onChange: event => {
      value[i][0] = event.target.value;
      onChange(value);
    },
    placeholder: 'From',
    type: "text",
    value: next[0],
    onFocus: () => setPillFocus(i),
    onBlur: () => setPillFocus(null),
    onKeyUp: onKeyUp
  }), /*#__PURE__*/React.createElement("input", {
    onChange: event => {
      value[i][1] = parseFloat(event.target.value);
      value[i][1] = isNaN(value[i][1]) ? null : value[i][1];
      onChange(value);
    },
    placeholder: 'Amount',
    type: "number",
    value: next[1],
    onFocus: () => setPillFocus(i),
    onBlur: () => setPillFocus(null),
    onKeyUp: onKeyUp
  }))), /*#__PURE__*/React.createElement("div", {
    className: "addPillButton",
    onClick: () => addPill()
  }, "+"))));
}

function PillPicker(props) {
  var {
    label,
    labelClass,
    onChange,
    selectItems,
    style = {},
    tooltipDiv,
    value
  } = props;

  var handlePillPickerChange = newValue => {
    var index = value.findIndex(item => item === newValue);

    if (index >= 0) {
      value.splice(index, 1);
    } else {
      value.push(newValue);
    }

    onChange(value);
  };

  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
    className: "pillPickerContainer",
    style: {
      gridTemplateColumns: `repeat(${selectItems.length}, 1fr)`
    }
  }, selectItems.map((item, i) => /*#__PURE__*/React.createElement("div", {
    className: classNames('pillPick', {
      selected: value.includes(item.value)
    }),
    key: i,
    onClick: () => handlePillPickerChange(item.value)
  }, item.label))));
}

function Select(props) {
  var {
    allowSelectCentering = true,
    label,
    labelClass,
    looping = true,
    onChange,
    selectItems,
    style = {},
    tooltipDiv,
    type,
    value
  } = props;
  var [divSelectOpen, setDivSelectOpen] = useState(false);
  var myRef = useRef();
  useEffect(() => {
    if (type === 'select' && divSelectOpen) {
      scrollDivSelectItems();
    }
  }, [divSelectOpen]);

  var scrollDivSelectItems = () => {
    var selectDiv = myRef.current;

    if (!selectDiv) {
      return;
    }

    var itemsContainer = selectDiv.querySelector('.itemsContainer');
    var selectedIndex = Math.max(0, selectItems.findIndex(item => item.value === value));
    var itemsAbove = selectedIndex; // var itemsBelow = selectItems.length - (selectedIndex + 1);

    if (itemsAbove >= 9) {
      itemsContainer.scrollTop = itemsAbove * 27 - 10;
    }

    if (allowSelectCentering) {
      var maxTop = -Math.min((selectDiv.getBoundingClientRect().top || Infinity) - 2, 225);
      itemsContainer.style.top = Math.max(-2 - (itemsAbove * 27 - itemsContainer.scrollTop), maxTop) + 'px';
    } else {
      if (itemsContainer.scrollTop > 0) {
        itemsContainer.style.top = -2 - 10 + 'px';
      } else {
        itemsContainer.style.top = '-2px';
      }
    }
  };

  var onDivSelectKeyUp = event => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation(); // doesn't seem to stop the scrolling, try something else

      var direction = event.key === 'ArrowDown' ? 1 : -1;
      var index = selectItems.findIndex(item => item.value === value);
      index = index + direction;

      if (looping) {
        index = (index + selectItems.length) % selectItems.length;
      } else {
        index = Math.max(0, Math.min(selectItems.length - 1, index));
      }

      onChange(selectItems[index].value);
    }

    ;
  };

  var divSelectOnBlur = () => {
    if (divSelectOpen) {
      setDivSelectOpen(false);
    }
  }; // make just a div, when click, display overlay and change state on hover/arrow down to highlight current
  // on mobile, have hidden select to trigger native ios selector?
  // show inner shadow when not scrolled all the way to top/bottom


  var selectedItem = selectItems.find(item => item.value === value) || {};
  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
    tabIndex: "0",
    className: "select",
    onClick: () => setDivSelectOpen(!divSelectOpen),
    onKeyUp: onDivSelectKeyUp,
    onBlur: divSelectOnBlur,
    ref: myRef
  }, /*#__PURE__*/React.createElement("span", {
    value: selectedItem.value
  }, selectedItem.label), /*#__PURE__*/React.createElement("div", {
    className: "selectArrow"
  }, "\u25BE"), divSelectOpen && /*#__PURE__*/React.createElement("div", {
    className: "itemsContainer"
  }, selectItems.map(item => /*#__PURE__*/React.createElement("div", {
    className: classNames({
      selected: item.value === value
    }),
    key: item.value,
    onClick: () => onChange(item.value),
    value: item.value
  }, item.label)))));
}

var months = [{
  value: 1,
  label: 'January',
  daysInMonth: 31
}, {
  value: 2,
  label: 'February',
  daysInMonth: 28
}, {
  value: 3,
  label: 'March',
  daysInMonth: 31
}, {
  value: 4,
  label: 'April',
  daysInMonth: 30
}, {
  value: 5,
  label: 'May',
  daysInMonth: 31
}, {
  value: 6,
  label: 'June',
  daysInMonth: 30
}, {
  value: 7,
  label: 'July',
  daysInMonth: 31
}, {
  value: 8,
  label: 'August',
  daysInMonth: 31
}, {
  value: 9,
  label: 'September',
  daysInMonth: 30
}, {
  value: 10,
  label: 'October',
  daysInMonth: 31
}, {
  value: 11,
  label: 'November',
  daysInMonth: 30
}, {
  value: 12,
  label: 'December',
  daysInMonth: 31
}];
var years = [];

for (var year = 1990; year <= parseInt(dateFormat('yyyy')); year++) {
  years.push({
    value: year,
    label: year.toString()
  });
}

function DateSelect(props) {
  var {
    label,
    labelClass,
    onChange,
    style = {},
    tooltipDiv,
    value
  } = props;

  var handleDateChange = (type, newValue) => {
    value = parseDate(value);

    if (type === 'month') {
      value = new Date(value.getFullYear(), newValue - 1, value.getDate());

      while (value.getMonth() !== newValue - 1) {
        value.setDate(value.getDate() - 1);
      }
    } else if (type === 'day') {
      value = new Date(value.getFullYear(), value.getMonth(), newValue);
    } else {
      value = new Date(newValue, value.getMonth(), value.getDate());
    }

    onChange(value);
  };

  value = parseDate(value);
  var dateCopy = new Date(value.getTime());
  dateCopy.setDate(1);
  dateCopy.setMonth(dateCopy.getMonth() + 1);
  dateCopy.setDate(0);
  var days = [];

  for (var day = 1; day <= dateCopy.getDate(); day++) {
    days.push({
      value: day,
      label: day.toString()
    });
  }

  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
    className: "dateContainer"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "select",
    selectItems: months,
    value: parseInt(dateFormat(value, 'm')),
    onChange: value => handleDateChange('month', value)
  }), /*#__PURE__*/React.createElement(Input, {
    type: "select",
    selectItems: days,
    value: parseInt(dateFormat(value, 'd')),
    onChange: value => handleDateChange('day', value)
  }), /*#__PURE__*/React.createElement(Input, {
    type: "select",
    selectItems: years,
    value: parseInt(dateFormat(value, 'yyyy')),
    onChange: value => handleDateChange('year', value)
  })));
}

var daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function DatePicker(props) {
  var {
    label,
    labelClass,
    onChange,
    style = {},
    tooltipDiv,
    value
  } = props;
  var [datePickerOpen, setDatePickerOpen] = useState(false);
  var [datePickerMonth, setDatePickerMonth] = useState(null);

  var setDatePickerValue = (event, day) => {
    var newValue = new Date(datePickerMonth.getTime());
    newValue.setDate(day);
    onChange(newValue);
    setDatePickerOpen(false);
    setDatePickerMonth(null);
    event.stopPropagation();
  };

  var onDatePickerKeyUp = event => {
    if (datePickerOpen) {
      return;
    }

    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation(); // doesn't seem to stop the scrolling, try something else

      var direction = event.key === 'ArrowDown' ? 1 : -1;
      var newValue = new Date(value.getTime());
      newValue.setDate(newValue.getDate() + direction);
      onChange(newValue);
    }
  };

  value = parseDate(value);

  if (datePickerOpen) {
    var currentDate = value.getDate();
    var isCurrentMonth = dateFormat(value, 'mm-yyyy') === dateFormat(datePickerMonth, 'mm-yyyy');
    var dateCopy = new Date(datePickerMonth.getTime());
    dateCopy.setDate(1);
    var blankSpaces = Array.from(Array(dateCopy.getDay()));
    dateCopy.setMonth(dateCopy.getMonth() - 1);
    var prevMonth = new Date(dateCopy.getTime());
    dateCopy.setMonth(dateCopy.getMonth() + 2);
    var nextMonth = new Date(dateCopy.getTime());
    dateCopy.setDate(0);
    var days = Array.from({
      length: dateCopy.getDate()
    }, (v, i) => i + 1);
  }

  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
    className: "datePickerContainer",
    tabIndex: "0",
    onClick: () => setDatePickerOpen(true) || setDatePickerMonth(new Date(value.getTime())),
    onKeyUp: event => onDatePickerKeyUp(event),
    onBlur: () => setDatePickerOpen(false) || setDatePickerMonth(null)
  }, /*#__PURE__*/React.createElement("span", {
    className: "currentDate"
  }, dateFormat(value, 'mmmm dS, yyyy')), /*#__PURE__*/React.createElement("div", {
    className: "datePickerArrow"
  }, "\u25BE"), datePickerOpen && /*#__PURE__*/React.createElement("div", {
    className: "datePicker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "datePickerHeader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "datePickerMonthArrow noSelect",
    onClick: e => setDatePickerMonth(prevMonth) || e.stopPropagation()
  }, "\u2190"), /*#__PURE__*/React.createElement("div", null, dateFormat(datePickerMonth, 'mmmm yyyy')), /*#__PURE__*/React.createElement("div", {
    className: "datePickerMonthArrow noSelect",
    onClick: e => setDatePickerMonth(nextMonth) || e.stopPropagation()
  }, "\u2192")), /*#__PURE__*/React.createElement("div", {
    className: "datePickerDaysContainer"
  }, daysOfWeek.map(d => /*#__PURE__*/React.createElement("div", {
    className: "datePickerDay datePickerLabel",
    key: d
  }, d)), blankSpaces.map((v, i) => /*#__PURE__*/React.createElement("div", {
    className: "datePickerDay datePickerBlank",
    key: `blank${i}`
  })), days.map(d => /*#__PURE__*/React.createElement("div", {
    className: classNames('datePickerDay', {
      selected: isCurrentMonth && d === currentDate
    }),
    key: `date${d}`,
    onClick: e => setDatePickerValue(e, d)
  }, d))))));
}

var hours = [{
  value: 12,
  label: '12'
}];

for (var hour = 1; hour < 12; hour++) {
  hours.push({
    value: hour,
    label: hour.toString()
  });
}

var minutes = [];

for (var minute = 0; minute <= 59; minute++) {
  minutes.push({
    value: minute,
    label: padNum(minute, 2)
  });
}

var amPm = [{
  value: 'am',
  label: 'AM'
}, {
  value: 'pm',
  label: 'PM'
}];

function TimeSelect(props) {
  var {
    label,
    labelClass,
    onChange,
    style = {},
    tooltipDiv,
    value
  } = props;

  var handleTimeChange = (type, newValue) => {
    var [hour, minute] = value.split(':').map(num => parseInt(num));
    var amPm = 'am';

    if (hour > 12) {
      amPm = 'pm';
    } else if (hour === 12) {
      amPm = 'pm';
    } else if (hour === 0) {
      hour = 12;
    }

    if (type === 'hour') {
      hour = newValue;

      if (amPm === 'am' && newValue === 12) {
        hour = 0;
      } else if (amPm === 'pm' && newValue !== 12) {
        hour += 12;
      }
    } else if (type === 'minute') {
      if (amPm === 'am' && hour === 12) {
        hour = 0;
      }

      minute = newValue;
    } else {
      if (newValue === 'am' && hour >= 12) {
        hour -= 12;
      } else if (newValue === 'pm' && hour !== 12) {
        hour += 12;
      }
    }

    onChange(`${padNum(hour, 2)}:${padNum(minute, 2)}`);
  };

  var [myHour, myMinute] = value.split(':').map(num => parseInt(num));
  var myAmPm = 'am';

  if (myHour > 12) {
    myAmPm = 'pm';
    myHour = myHour % 12;
  } else if (myHour === 12) {
    myAmPm = 'pm';
  } else if (myHour === 0) {
    myHour = 12;
  }

  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("div", {
    className: "timeContainer"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "select",
    selectItems: hours,
    value: myHour,
    onChange: value => handleTimeChange('hour', value)
  }), /*#__PURE__*/React.createElement(Input, {
    type: "select",
    selectItems: minutes,
    value: myMinute,
    onChange: value => handleTimeChange('minute', value)
  }), /*#__PURE__*/React.createElement(Input, {
    type: "select",
    selectItems: amPm,
    value: myAmPm,
    onChange: value => handleTimeChange('ampm', value)
  })));
}

function FileDrop(props) {
  var {
    labelClass,
    onChange,
    value
  } = props;
  var [fileDragActive, setFileDragActive] = useState(false);
  var fileInputRef = useRef();

  var handleFileDrag = event => {
    event.preventDefault();
    event.stopPropagation();

    if (event.type === 'dragenter' || event.type === 'dragover') {
      setFileDragActive(true);
    } else if (event.type === 'dragleave') {
      setFileDragActive(false);
    }
  };

  var handleFileDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    setFileDragActive(false);

    if (event.dataTransfer.files?.length) {
      onChange([...event.dataTransfer.files]);
    }
  };

  var handleFileChange = event => onChange([...event.target.files]);

  return /*#__PURE__*/React.createElement("label", {
    className: classNames(labelClass, 'fileDropContainer', {
      fileDragActive
    }),
    onDragEnter: handleFileDrag,
    onDragLeave: handleFileDrag,
    onDragOver: handleFileDrag,
    onDrop: handleFileDrop
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    multiple: true,
    onChange: handleFileChange,
    ref: fileInputRef
  }), !!value?.length ? value.map(file => /*#__PURE__*/React.createElement("div", {
    className: "fileDropMessage",
    key: file.name
  }, file.name)) : /*#__PURE__*/React.createElement("div", {
    className: "fileDropMessage"
  }, "Drag and drop your file(s) here or"), /*#__PURE__*/React.createElement(Input, {
    type: "button",
    label: "Upload File(s)",
    onClick: () => fileInputRef.current.click()
  }));
}

function TextInput(props) {
  var {
    autoFocus = false,
    label,
    labelClass,
    onChange,
    onKeyUp,
    onFocus,
    onBlur,
    onClick,
    placeholder,
    style,
    tooltipDiv,
    type,
    value
  } = props;
  var myRef = useRef();
  useEffect(() => {
    if (autoFocus) {
      var input = myRef.current;
      var name = input.nodeName.toLowerCase();

      if (name === 'input') {
        input.focus();
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement("label", {
    className: labelClass,
    style: style
  }, label && /*#__PURE__*/React.createElement("span", null, label, tooltipDiv), /*#__PURE__*/React.createElement("input", {
    className: "inputBox",
    onChange: event => onChange(event.target.value),
    placeholder: placeholder,
    ref: myRef,
    type: type,
    value: value,
    onKeyUp: onKeyUp,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: onClick
  }));
}

var inputComponents = {
  singlePill: SinglePill,
  doublePill: DoublePill,
  pillPicker: PillPicker,
  select: Select,
  date: DatePicker,
  dateManual: DateSelect,
  time: TimeSelect,
  file: FileDrop,
  text: TextInput
};
export default Input;